import { styledByTheme } from '../../../../themes/architecture/styled-by-theme';
import { SwiperGamesListDefaultBox } from './swiper-games-list.default.box';
import { SwiperGamesListSICisBox } from './swiper-games-list.siCis.box';

export const SwiperGamesListBox = styledByTheme(SwiperGamesListDefaultBox)
    .forSICis(SwiperGamesListSICisBox)
    .apply();